
// shader that draws the active texture (image) and applies post-processing to its colors.
export const fragment = `
precision highp float;

uniform sampler2D texture;

uniform float lightness_min;
uniform float lightness_max;

const float LIGHTNESS_STRENGTH = 0.75;

uniform float saturation_min;
uniform float saturation_max;

const float SATURATION_STRENGTH = 1.25;

varying vec2 v_uv;

const vec3 LUMINANCE_WEIGHTS = vec3(0.2126, 0.7152, 0.0722);

float lightness(vec3 linear) {
    return dot(linear, LUMINANCE_WEIGHTS);
}

float saturation(vec3 rgb) {
    float maxVal = max(max(rgb.r, rgb.g), rgb.b);
    float minVal = min(min(rgb.r, rgb.g), rgb.b);
    float lightness = (maxVal + minVal) * 0.5;

    if (lightness < 0.001 || lightness > 0.999) {
        return 0.0; // No saturation at pure black or white
    }

    float delta = maxVal - minVal;
    return delta / (1.0 - abs(2.0 * lightness - 1.0));
}

vec3 adjust_saturation(vec3 rgb, float adjustment) {
    float lum = dot(rgb, LUMINANCE_WEIGHTS);
    vec3 relative = rgb - lum;
    vec3 adjusted = lum + relative * (1.0 + adjustment);
    return adjusted;
}

mat3 brightness_matrix(float strength) {
    return mat3(
        1.0 + strength, 0.0, 0.0,
        0.0, 1.0 + strength, 0.0,
        0.0, 0.0, 1.0 + strength
    );
}

void main() {
    vec4 color = texture2D(texture, v_uv);
    vec3 originalColor = color.rgb;

    float currentLightness = lightness(originalColor);
    float currentSaturation = saturation(originalColor);

    if (lightness_min > currentLightness) {
        float diff = lightness_min - currentLightness;
        color.rgb *= brightness_matrix(diff * LIGHTNESS_STRENGTH);
    }

    if (lightness_max < currentLightness) {
        float diff = currentLightness - lightness_max;
        color.rgb *= brightness_matrix(-diff * LIGHTNESS_STRENGTH);
    }

    if (saturation_min > currentSaturation) {
        float diff = saturation_min - currentSaturation;
        color.rgb = adjust_saturation(color.rgb, diff * SATURATION_STRENGTH);
    }

    if (saturation_max < currentSaturation) {
        float diff = currentSaturation - saturation_max;
        color.rgb = adjust_saturation(color.rgb, -diff * SATURATION_STRENGTH);
    }

    color.rgb = clamp(color.rgb, 0.0, 1.0);

    gl_FragColor = color;
}
`;